import mutations from './vaccination.mutations'
import actions from './vaccination.actions'
import getters from './vaccination.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
